import {Linking, Platform, Alert} from 'react-native';
import {urlProtocolSet} from '../utils/text';

export const openExternalLink = async (url?: string, target?: string | undefined): Promise<void> => {
  if (!url) {
    return;
  }

  if (Platform.OS === 'web') {
    const targetNormalized = (target ?? '').replace(/["']/g, '').trim().toLowerCase();
    const normalizedTarget = targetNormalized === '_blank' ? '_blank' : '_self';
    window.open(urlProtocolSet(url), normalizedTarget);
    return;
  }

  const canOpen = await Linking.canOpenURL(urlProtocolSet(url));
  if (!canOpen) {
    Alert.alert('Не удалось открыть ссылку');
    return;
  }

  await Linking.openURL(urlProtocolSet(url));
};

export const openExternalPhone = async (phoneNum?: string): Promise<void> => {
  if (!phoneNum || Platform.OS === 'web') {
    return;
  }
  let phoneNumber = phoneNum;
  if (Platform.OS !== 'android') {
    phoneNumber = `telprompt:${phoneNum}`;
  } else {
    phoneNumber = `tel:${phoneNum}`;
  }
  if (await Linking.canOpenURL(phoneNumber)) {
    await Linking.openURL(phoneNumber);
  } else Alert.alert('Не удалось открыть номер');
};
